import { boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../organization/Id';

import { Id } from './Id';
import { Id as PrincipalTypeId } from './principal-type/Id';

export const RefItem = intersect(
	struct({
		id: Id,

		principalType: PrincipalTypeId,
	})
)(
	partial({
		name: string,

		organizationId: OrganizationId,

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
